module.exports = __webpack_public_path__ + "public/StoreIcon/earnings.svg?576b2277";